<template>
  <div :class="$style.pageContent">
    <div class="isStylePageContent" style="padding-bottom: 8rem">
      <!-- 服務 -->
      <el-row :gutter="20">
        <el-col :lg="24" :span="24">
          <h3>適用服務項目</h3>
          <h6 class="fs-base fw-regular text-text">適用分店及服務項目</h6>
          <el-row :gutter="0">
            <el-col :sm="12" :span="24">
              <div :class="[$style.box, $style.isRightNoBorder, $style.isRightNoRadius]">
                <template>
                  <div class="inner-box">
                    <el-button v-for="(item, index) in storeItems" :disabled="disableComputed(item.id)"
                      @click="deleteStore(item.id)" :key="index" class="is-round is-fullwidth"
                      style="text-align: left; :none ">
                      <span class="flex-btn">
                        <span class="btn-text">{{ item.name }}</span>
                        <div style="cursor: pointer; padding: 10px; margin: -10px">
                          <BaseIcon name="times"></BaseIcon>
                        </div>
                      </span>
                    </el-button>
                    <span v-if="!storeItems.length">請選擇適用分店</span>
                  </div>
                </template>
                <el-button class="is-round is-fullwidth" @click="storeDialogVisible = true">
                  <BaseIcon name="plus" /> 新增適用分店
                </el-button>
              </div>
            </el-col>

            <el-col :sm="12" :span="24">
              <div :class="[$style.box, $style.isLeftNoRadius]">
                <template>
                  <div class="inner-box">
                    <el-button v-for="(item, index) in serviceItems" :key="index" class="is-round is-fullwidth"
                      style="text-align: left; :none " @click="deleteService(item.id)">
                      <span class="flex-btn">
                        <span class="btn-text">{{ item.title }} <span class="text-muted-0">({{ item.petCategoryTitle
                        }})</span></span>
                        <div style="cursor: pointer; padding: 10px; margin: -10px">
                          <BaseIcon name="times"></BaseIcon>
                        </div>
                      </span>
                    </el-button>
                    <span v-if="!serviceItems.length">請選擇服務項目</span>
                  </div>
                </template>
                <el-button class="is-round is-fullwidth" @click="servicesDialogVisible = true">
                  <BaseIcon name="plus" /> 新增適用服務項目
                </el-button>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <!-- 商品 -->
      <el-row :gutter="20" v-if="hasGoods">
        <el-col :lg="24" :span="24">
          <h3>適用商品項目</h3>
          <h6 class="fs-base fw-regular text-text">適用分店及商品項目</h6>
          <el-row :gutter="0">
            <el-col :sm="12" :span="24">
              <div :class="[$style.box, $style.isRightNoBorder, $style.isRightNoRadius]">
                <template>
                  <div class="inner-box">
                    <el-button v-for="(item, index) in goodsStoreItems" :disabled="disableComputed(item.id)"
                      @click="deleteGoodsStore(item.id)" :key="index" class="is-round is-fullwidth"
                      style="text-align: left; :none ">
                      <span class="flex-btn">
                        <span class="btn-text">{{ item.name }}</span>
                        <div style="cursor: pointer; padding: 10px; margin: -10px">
                          <BaseIcon name="times"></BaseIcon>
                        </div>
                      </span>
                    </el-button>
                    <span v-if="!goodsStoreItems.length">請選擇適用分店</span>
                  </div>
                </template>
                <el-button class="is-round is-fullwidth" @click="goodsStoreDialogVisible = true">
                  <BaseIcon name="plus" /> 新增適用分店
                </el-button>
              </div>
            </el-col>

            <el-col :sm="12" :span="24">
              <div :class="[$style.box, $style.isLeftNoRadius]">
                <template>
                  <div class="inner-box">
                    <el-button v-for="(item, index) in goodsServiceItems" :key="index" class="is-round is-fullwidth"
                      style="text-align: left; :none " @click="deleteGoodsService(item.id)">
                      <span class="flex-btn">
                        <span class="btn-text">{{ item.title }} </span>
                        <div style="cursor: pointer; padding: 10px; margin: -10px">
                          <BaseIcon name="times"></BaseIcon>
                        </div>
                      </span>
                    </el-button>
                    <span v-if="!goodsServiceItems.length">請選擇商品項目</span>
                  </div>
                </template>
                <el-button class="is-round is-fullwidth" @click="goodsServiceDialogVisible = true">
                  <BaseIcon name="plus" /> 新增適用商品項目
                </el-button>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <!-- 適用分店(服務項目) -->
    <el-dialog title="選取適用分店" :visible.sync="storeDialogVisible" width="80%" top="0" append-to-body
      @close="cancelSelectedStoresIds">
      <el-form label-position="top" class="isWrap">
        <el-form-item>
          <el-input v-model="storeSearchText" placeholder="搜尋" class="search-in-box" @input="searchStores">
            <BaseIcon slot="suffix" name="search" class="el-input__icon" />
          </el-input>
        </el-form-item>
        <el-form-item style="min-height: 250px" :class="$style['services-wrap']">
          <el-checkbox v-model="checkAllStoreIds" :indeterminate="isIndeterminateStores" class="check-all"
            @change="toggleAllStoreIds">全選</el-checkbox>
          <el-checkbox-group v-model="selectedStoreIds" :class="$style.services" @change="searchStores">
            <el-row :gutter="20">
              <template v-for="(product, index) in filterGoodsStores">
                <el-col :key="index" :md="12" :span="24">
                  <el-checkbox :key="index" :label="product.id" border :disabled="disableComputed(product.id)">
                    {{ product.name }}
                  </el-checkbox>
                </el-col>
              </template>
            </el-row>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div class="btn-group-inline">
        <el-button class="is-round" @click="cancelSelectedStoresIds">取消</el-button>
        <el-button class="is-round" type="primary" @click="saveSelectedStoreIds">儲存</el-button>
      </div>
    </el-dialog>

    <!-- 適用分店(商品項目) -->
    <el-dialog title="選取適用分店" :visible.sync="goodsStoreDialogVisible" width="80%" top="0" append-to-body
      @close="cancelSelectedGoodsStoresIds">
      <el-form label-position="top" class="isWrap">
        <el-form-item>
          <el-input v-model="goodsStoreSearchText" placeholder="搜尋" class="search-in-box" @input="searchGoodsStores">
            <BaseIcon slot="suffix" name="search" class="el-input__icon" />
          </el-input>
        </el-form-item>
        <el-form-item style="min-height: 250px" :class="$style['services-wrap']">
          <el-checkbox v-model="checkAllGoodsStoreIds" :indeterminate="isIndeterminateGoodsStores" class="check-all"
            @change="toggleAllGoodsStoreIds">全選</el-checkbox>
          <el-checkbox-group v-model="selectedGoodsStoreIds" :class="$style.services" @change="searchGoodsStores">
            <el-row :gutter="20">
              <template v-for="(product, index) in filterGoodsStores">
                <el-col :key="index" :md="12" :span="24">
                  <el-checkbox :key="index" :label="product.id" border :disabled="disableComputed(product.id)">
                    {{ product.name }}
                  </el-checkbox>
                </el-col>
              </template>
            </el-row>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div class="btn-group-inline">
        <el-button class="is-round" @click="cancelSelectedGoodsStoresIds">取消</el-button>
        <el-button class="is-round" type="primary" @click="saveSelectedGoodsStoreIds">儲存</el-button>
      </div>
    </el-dialog>

    <!-- 適用服務項目 -->
    <el-dialog title="選取適用服務" :visible.sync="servicesDialogVisible" width="80%" top="0" append-to-body>
      <el-form label-position="top" class="isWrap">
        <el-form-item>
          <el-input v-model="serviceSearchText" placeholder="搜尋" class="search-in-box" @input="searchServices">
            <BaseIcon slot="suffix" name="search" class="el-input__icon" />
          </el-input>
        </el-form-item>
        <el-form-item style="min-height: 250px" :class="$style['services-wrap']">
          <el-checkbox v-model="checkAllServiceIds" :indeterminate="isIndeterminateServices" class="check-all"
            @change="toggleAllServiceIds">
            全選
          </el-checkbox>
          <el-checkbox-group v-model="selectedServiceIds" :class="$style.services">
            <el-row :gutter="20">
              <template v-for="(price, index) in filterServices">
                <el-col :key="index" :md="12" :span="24">
                  <el-checkbox :key="index" :label="price.id" border>
                    {{ price.title }} <span class="text-muted-0">({{ price.petCategoryTitle }})</span>
                  </el-checkbox>
                </el-col>
              </template>
            </el-row>
          </el-checkbox-group>
        </el-form-item>
      </el-form>

      <div class="btn-group-inline">
        <el-button class="is-round" @click="cancelSelectedServiceIds">取消</el-button>
        <el-button class="is-round" type="primary" @click="saveSelectedServiceIds">儲存</el-button>
      </div>
    </el-dialog>

    <!-- 適用服務項目(商品) -->
    <el-dialog title="選取適用服務" :visible.sync="goodsServiceDialogVisible" width="80%" top="0" append-to-body>
      <el-form label-position="top" class="isWrap">
        <el-form-item>
          <el-input v-model="goodsServiceSearchText" placeholder="搜尋" class="search-in-box" @input="searchGoodsServices">
            <BaseIcon slot="suffix" name="search" class="el-input__icon" />
          </el-input>
        </el-form-item>
        <el-form-item style="min-height: 250px" :class="$style['services-wrap']">
          <el-checkbox v-model="checkAllGoodsServiceIds" :indeterminate="isIndeterminateGoodsServices" class="check-all"
            @change="toggleAllGoodsServiceIds">
            全選
          </el-checkbox>
          <el-checkbox-group v-model="selectedGoodsServiceIds" :class="$style.services">
            <el-row :gutter="20">
              <template v-for="(price, index) in filterGoodsServices">
                <el-col :key="index" :md="12" :span="24">
                  <el-checkbox :key="index" :label="price.id" border>
                    {{ price.title }}
                  </el-checkbox>
                </el-col>
              </template>
            </el-row>
          </el-checkbox-group>
        </el-form-item>
      </el-form>

      <div class="btn-group-inline">
        <el-button class="is-round" @click="cancelSelectedGoodsServiceIds">取消</el-button>
        <el-button class="is-round" type="primary" @click="saveSelectedGoodsServiceIds">儲存</el-button>
      </div>
    </el-dialog>

    <div :class="$style.footer">
      <el-button class="is-round" @click="onClickLeave">取消編輯</el-button>
      <el-button class="is-round" type="primary" :loading="tryingStore" @click="tryToStore">儲存編輯</el-button>
    </div>
  </div>
</template>

<script>
import { messageStore } from '@utils/message'
import productMixin from '@/src/mixins/product'
import { authComputed } from '@state/helpers'

export default {
  name: 'CouponAssigned',
  components: {},
  mixins: [productMixin],
  props: {
    defaultValue: {
      type: Object,
      default: () => ({}),
    },
    // 分店
    products: {
      type: Array,
      default: () => [],
    },
    // 服務
    prices: {
      type: Array,
      default: () => [],
    },
    goods: {
      type: Array,
      default: () => [],
    },
    prepaids: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedStoreIds: [],
      selectedServiceIds: [],
      selectedGoodsStoreIds: [],
      selectedGoodsServiceIds: [],

      checkAllStoreIds: false,
      checkAllServiceIds: false,
      checkAllGoodsStoreIds: false,
      checkAllGoodsServiceIds: false,

      storeSearchText: '',
      serviceSearchText: '',
      goodsStoreSearchText: '',
      goodsServiceSearchText: '',

      storeDialogVisible: false,
      servicesDialogVisible: false,
      goodsStoreDialogVisible: false,
      goodsServiceDialogVisible: false,

      // ???
      tryingStore: false,
    }
  },
  computed: {
    submitData: {
      get() {
        return this.defaultValue
      },
      set(value) {
        this.$emit('update:defaultValue', value)
      },
    },

    // filter
    filterStores() {
      if (this.storeSearchText.length === 0) {
        return this.products
      } else {
        return this.products.filter((item) => item.name.includes(this.storeSearchText))
      }
    },
    filterServices() {
      if (this.serviceSearchText.length === 0) {
        return this.prices
      } else {
        return this.prices.filter((item) => item.title.includes(this.serviceSearchText))
      }
    },
    filterGoodsStores() {
      if (this.goodsStoreSearchText.length === 0) {
        return this.products
      } else {
        return this.products.filter((item) => item.name.includes(this.goodsStoreSearchText))
      }
    },
    filterGoodsServices() {
      if (this.goodsServiceSearchText.length === 0) {
        return this.goods
      } else {
        return this.goods.filter((item) => item.title.includes(this.goodsServiceSearchText))
      }
    },

    // isIndeterminate
    isIndeterminateStores() {
      if (this.selectedStoreIds.length === 0) return false
      return this.selectedStoreIds.length > 0 && this.selectedStoreIds.length < this.filterStores.length
    },
    isIndeterminateServices() {
      if (this.selectedServiceIds.length === 0) return false
      return this.selectedServiceIds.length > 0 && this.selectedServiceIds.length < this.filterServices.length
    },
    isIndeterminateGoodsStores() {
      if (this.selectedGoodsStoreIds.length === 0) return false
      return this.selectedGoodsStoreIds.length > 0 && this.selectedGoodsStoreIds.length < this.filterGoodsStores.length
    },
    isIndeterminateGoodsServices() {
      if (this.selectedGoodsServiceIds.length === 0) return false
      return this.selectedGoodsServiceIds.length > 0 && this.selectedGoodsServiceIds.length < this.filterGoodsServices.length
    },
    // items
    storeItems() {
      return this.products.filter((item) => {
        return this.selectedStoreIds.includes(item.id)
      })
    },
    serviceItems() {
      return this.prices.filter((item) => {
        return this.selectedServiceIds.includes(item.id)
      })
    },
    goodsStoreItems() {
      return this.products.filter((item) => {
        return this.selectedGoodsStoreIds.includes(item.id)
      })
    },
    goodsServiceItems() {
      return this.goods.filter((item) => {
        return this.selectedGoodsServiceIds.includes(item.id)
      })
    },
    ...authComputed,
  },
  created() {
    this.setItems()
  },
  methods: {
    setItems() {
      if (this.defaultValue?.storeIds.length) {
        this.selectedStoreIds = [...this.defaultValue.storeIds]
      }
      if (this.defaultValue?.serviceIds.length) {
        this.selectedServiceIds = [...this.defaultValue.serviceIds]
      }
      if (this.defaultValue?.goodsStoreIds.length) {
        this.selectedGoodsStoreIds = [...this.defaultValue.goodsStoreIds]
      }
      if (this.defaultValue?.goodsServiceIds.length) {
        this.selectedGoodsServiceIds = [...this.defaultValue.goodsServiceIds]
      }
    },

    // save
    saveSelectedStoreIds() {
      this.defaultValue.storeIds = [...this.selectedStoreIds]
      this.storeDialogVisible = false
    },
    saveSelectedServiceIds() {
      this.defaultValue.serviceIds = [...this.selectedServiceIds]
      this.servicesDialogVisible = false
    },
    saveSelectedGoodsStoreIds() {
      this.defaultValue.goodsStoreIds = [...this.selectedGoodsStoreIds]
      this.goodsStoreDialogVisible = false
    },
    saveSelectedGoodsServiceIds() {
      this.defaultValue.goodsServiceIds = [...this.selectedGoodsServiceIds]
      this.goodsServiceDialogVisible = false
    },

    // cancel
    cancelSelectedStoresIds() {
      this.selectedStoreIds = [...this.defaultValue.storeIds.map((item) => item)]
      this.storeDialogVisible = false
    },
    cancelSelectedServiceIds() {
      this.selectedServiceIds = [...this.defaultValue.serviceIds.map((item) => item)]
      this.servicesDialogVisible = false
    },
    cancelSelectedGoodsStoresIds() {
      this.selectedGoodsStoreIds = [...this.defaultValue.goodsStoreIds.map((item) => item)]
      this.goodsStoreDialogVisible = false
    },
    cancelSelectedGoodsServiceIds() {
      this.selectedGoodsServiceIds = [...this.defaultValue.goodsServiceIds.map((item) => item)]
      this.goodsServiceDialogVisible = false
    },

    // toggleAll
    toggleAllStoreIds(checked) {
      const permissionObj = this.$store.state.auth.currentUserPermission
      if (permissionObj.isStoreAdmin) {
        this.selectedStoreIds = this.checkAllForIsStoreAdmin(checked, this.selectedStoreIds, this.products)
        return
      }
      const selectedStoreIds = [...this.selectedStoreIds]
      if (checked) {
        const stores = this.filterStores.filter((item) => {
          return !this.selectedServiceIds.includes(item.id)
        })
        this.selectedStoreIds = [...selectedStoreIds, ...stores.map((item) => item.id)]
        this.selectedStoreIds = this.notCheckAllInPermission(this.selectedStoreIds)
      } else {
        const stores = [...this.filterStores.map((item) => item.id)]
        this.selectedStoreIds = [...selectedStoreIds.filter((item) => !stores.includes(item))]
      }
    },
    toggleAllServiceIds(checked) {
      const selectedServiceIds = [...this.selectedServiceIds]
      if (checked) {
        const service = this.filterServices.filter((item) => {
          return !this.selectedServiceIds.includes(item.id)
        })
        this.selectedServiceIds = [...selectedServiceIds, ...service.map((item) => item.id)]
      } else {
        const service = [...this.filterServices.map((item) => item.id)]
        this.selectedServiceIds = [...selectedServiceIds.filter((item) => !service.includes(item))]
      }
    },
    toggleAllGoodsStoreIds(checked) {
      const permissionObj = this.$store.state.auth.currentUserPermission
      if (permissionObj.isStoreAdmin) {
        this.selectedGoodsStoreIds = this.checkAllForIsStoreAdmin(checked, this.selectedGoodsStoreIds, this.products)
        return
      }
      const selectedGoodsStoreIds = [...this.selectedGoodsStoreIds]
      if (checked) {
        const stores = this.filterGoodsStores.filter((item) => {
          return !this.selectedGoodsServiceIds.includes(item.id)
        })
        this.selectedGoodsStoreIds = [...selectedGoodsStoreIds, ...stores.map((item) => item.id)]
        this.selectedGoodsStoreIds = this.notCheckAllInPermission(this.selectedGoodsStoreIds)
      } else {
        const stores = [...this.filterGoodsStores.map((item) => item.id)]
        this.selectedGoodsStoreIds = [...selectedGoodsStoreIds.filter((item) => !stores.includes(item))]
      }
    },
    toggleAllGoodsServiceIds(checked) {
      const selectedGoodsServiceIds = [...this.selectedGoodsServiceIds]
      if (checked) {
        const service = this.filterGoodsServices.filter((item) => {
          return !this.selectedGoodsServiceIds.includes(item.id)
        })
        this.selectedGoodsServiceIds = [...selectedGoodsServiceIds, ...service.map((item) => item.id)]
      } else {
        const service = [...this.filterGoodsServices.map((item) => item.id)]
        this.selectedGoodsServiceIds = [...selectedGoodsServiceIds.filter((item) => !service.includes(item))]
      }
    },

    // delete
    deleteStore(id) {
      this.selectedStoreIds.forEach((item, index) => {
        if (item === id) {
          this.selectedStoreIds.splice(index, 1)
          this.defaultValue.storeIds.splice(index, 1)
        }
      })
      if(!this.selectedStoreIds.length) this.checkAllStoreIds = false
    },
    deleteService(alias) {
      this.selectedServiceIds.forEach((item, index) => {
        if (item === alias) {
          this.selectedServiceIds.splice(index, 1)
          this.defaultValue.serviceIds.splice(index, 1)
        }
      })
      if(!this.selectedServiceIds.length) this.checkAllServiceIds = false
    },
    deleteGoodsStore(id) {
      this.selectedGoodsStoreIds.forEach((item, index) => {
        if (item === id) {
          this.selectedGoodsStoreIds.splice(index, 1)
          this.defaultValue.goodsStoreIds.splice(index, 1)
        }
      })
      if(!this.selectedGoodsStoreIds.length) this.checkAllGoodsStoreIds = false
    },
    deleteGoodsService(alias) {
      this.selectedGoodsServiceIds.forEach((item, index) => {
        if (item === alias) {
          this.selectedGoodsServiceIds.splice(index, 1)
          this.defaultValue.goodsServiceIds.splice(index, 1)
        }
      })
      if(!this.selectedGoodsServiceIds.length) this.checkAllGoodsServiceIds = false
    },

    // search
    searchStores() {
      this.checkAllStoreIds = this.filterStores.every((item) => this.selectedStoreIds.includes(item.id))
    },
    searchServices() {
      this.checkAllServiceIds = this.filterServices.every((item) => this.selectedServiceIds.includes(item.id))
    },
    searchGoodsStores() {
      this.checkAllGoodsStoreIds = this.filterGoodsStores.every((item) => this.selectedGoodsStoreIds.includes(item.id))
    },
    searchGoodsServices() {
      this.checkAllGoodsServiceIds = this.filterGoodsServices.every((item) => this.selectedGoodsServiceIds.includes(item.id))
    },

    async tryToStore() {
      try {
        this.tryingStore = true
        await this.$store.dispatch('merchant/postCosmeticBasicSet', {
          type: 'deposit',
          payload: this.defaultValue,
        })
        this.$emit('update')
        messageStore('edit')
      } catch {
      } finally {
        this.tryingStore = false
      }
    },
    onClickLeave() { },
  },
}
</script>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';

:global {
  .isWrap {
    .el-checkbox.is-bordered {
      background-color: #fff;

      .el-checkbox__label {
        white-space: normal;
      }
    }
  }
}

.box {
  background-color: #f9f9f9;
  border: $color-border-light 1px solid;
  padding: 15px;
  border-radius: 6px;

  &.isRightNoBorder {
    border-right-width: 0;

    @include max-sm {
      border-right: $color-border-light 1px solid;
      border-bottom: 0;
    }
  }

  &.isRightNoRadius {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;

    @include max-sm {
      border-top-right-radius: 6px;
      border-bottom-left-radius: 0;
    }
  }

  &.isLeftNoRadius {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

    @include max-sm {
      border-bottom-left-radius: 6px;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }

  :global {
    .inner-box {
      margin-bottom: 20px;
      height: calc(100vh - 380px);
      overflow-y: scroll;

      .el-button {
        &.isBig {
          height: 65px;
        }
      }
    }

    .box {
      &__title {
        white-space: normal;
        text-align: left;
        line-height: 1.4;
        max-width: calc(100% - 100px);
      }
    }

    .el-checkbox-group {
      // display: flex;
      // flex-wrap: wrap;
    }

    .el-checkbox.is-bordered {
      background-color: #fff;

      .el-checkbox__label {
        white-space: normal;
      }
    }

    .search-in-box {
      .el-input__inner {
        background-color: #fff;
        margin-left: 5px;
        margin-right: 5px;
        margin-bottom: 10px;
      }
    }

    .input-in-buttom {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
    }

    .el-form-item {
      margin-bottom: 15px;
    }

    .el-button {
      .el-input {
        width: 100px;
      }

      .el-input__inner {
        background-color: #fff;
        border-color: $color-border-base;
        height: 30px;

        &:focus {
          // border-color: $color-primary;
        }
      }

      .el-input__suffix {
        top: 7px;
      }
    }

    .inline-section {
      display: flex;
      margin-bottom: 15px;
    }

    .el-button.is-no-border {
      border: 0;
    }
  }
}

.services-wrap {
  // margin: 0 -5px 30px;
  border: 1px solid $color-line-dark;
  border-radius: 8px;
  overflow: hidden;
  padding-bottom: 14px;
  margin-bottom: 2rem;
  background: #fff;

  :global {
    .check-all {
      display: block;
      background: $color-line;
      border: none;
      padding: 0 18px;

      .el-checkbox__label {
        color: $color-text-light;
      }
    }
  }
}

.services {
  padding: 0 18px 10px;
  border-top: 1px solid $color-line;
  display: block;

  :global {
    label.el-checkbox.is-bordered {
      display: flex;
      width: 100%;
      margin-top: 14px;
      align-items: center;
      height: auto;
      padding: 15px 20px 15px 15px;
      margin-left: 0;
      margin-right: 0;

      .el-checkbox__inner {
        &:after {}
      }

      .el-checkbox__label {
        width: 100%;
      }

      &+.el-checkbox.is-bordered {
        margin-left: 0;
      }

      .title,
      .meta {
        width: calc(100% - 20px);
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
      }

      .content {
        width: 100%;
      }
    }

    label.el-radio.is-bordered {
      width: calc(50% - 10px);
      display: inline-flex;
      margin: 5px;
      align-items: center;
      height: auto;
      padding: 15px 20px 15px 15px;

      @include max-sm {
        width: 100%;
      }

      .el-radio__label {
        padding-left: 15px;
        width: 100%;
      }

      &+.el-radio.is-bordered {
        margin-left: 5px;
      }

      .title,
      .meta {
        width: calc(100% - 20px);
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
      }

      .content {
        width: 100%;
      }
    }
  }
}
</style>
